import './Array.js';;
import 'whatwg-fetch';
import { Promise } from 'es6-promise';

if (!(<any>window).Promise) {
    (<any>window).Promise = Promise;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/component/polyfills.ts